<div #sideMenuContainer
  class="side-menu-container absolute lg:relative lg:block w-full lg:w-64 h-screen max-h-screen overflow-y-auto bg-surface transition-transform duration-300 ease-in-out lg:rounded-r-3xl select-none"
  [class.-translate-x-full]="!expanded()" (touchstart)="onSwipeStart($event)">
  <div #sideMenuContent class="h-full overflow-y-auto pad-safe-area-top-10 px-2 select-none">
    <ng-content></ng-content>
  </div>
</div>